<div class="list-page">
  <h2>Tilintarkastaja</h2>

  @if (tilintarkastaja()?.avain && kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px; margin-left: 20px">
      <h3 style="margin: 0 0 1em">Urit</h3>
      <div style="padding-left: 1em; padding-right: 1em; padding-bottom: 1em">
        <div>
          Tilintarkastaja (Lemonator): <a [href]="tilintarkastajaEncodedUriObservable | async" target="_BLANK">{{ tilintarkastajaUriObservable | async }}</a>
        </div>
      </div>
      @if (tilintarkastaja()?.avain) {
        <app-button (click)="naytaLoginHistoriaa()" actionId="Näytä tilintarkastajan login historia" styles="cursor: pointer; color: #2dc8fa; line-height: 0;"> Kirjautumishistoria </app-button>
      }
    </div>
  }

  <!-- Tilintarkastajan tiedot -->
  <div style="display: flex; align-items: center; gap: 1em">
    <h3 style="margin: 0">Perustiedot</h3>
  </div>
  @if ((kirjanpitajaOnSuperObservable | async) && tilintarkastaja()?.avain) {
    <div style="margin-bottom: 12px; padding: 10px 0px; font-size: 13px; color: #555">
      Avain:
      <span style="font-family: monospace; cursor: pointer; padding: 5px 6px; background-color: #f5f5f5; border-radius: 3px" (click)="kopioiAvain()" matTooltip="Klikkaa kopioidaksesi superuser-kirjautumista varten">{{ tilintarkastaja().avain }}</span>
    </div>
  }
  <form style="max-width: 600px">
    <mat-form-field>
      <mat-label>Etunimi</mat-label>
      <input matInput [formField]="lomake.etunimi" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Sukunimi</mat-label>
      <input matInput [formField]="lomake.sukunimi" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput [formField]="lomake.email" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Hetu</mat-label>
      <input matInput [formField]="lomake.hetu" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Tila</mat-label>
      <mat-select [formField]="lomake.tila">
        <mat-option [value]="null">Ei tilaa</mat-option>
        <mat-option value="kutsuttu">{{ TILINTARKASTAJAN_TILA_TEKSTI['kutsuttu'] }}</mat-option>
        <mat-option value="tunnistautunut">{{ TILINTARKASTAJAN_TILA_TEKSTI['tunnistautunut'] }}</mat-option>
        <mat-option value="hylatty">{{ TILINTARKASTAJAN_TILA_TEKSTI['hylatty'] }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox [formField]="lomake.poistettu">Poistettu</mat-checkbox>

    <div style="max-width: 450px">
      <div style="display: flex; justify-content: space-evenly; margin-top: 1em; margin-bottom: 2em">
        <app-secondary-button (click)="peruuta()" actionId="Peruuta (tilintarkastajan tiedot)">{{ 'yleiset.peruuta' | translate | async }}</app-secondary-button>
        <app-primary-button (click)="save()" actionId="Tallenna tilintarkastajan tiedot" [actionContext]="[this.tilintarkastaja().avain]">{{ 'yleiset.tallenna' | translate | async }}</app-primary-button>
      </div>
    </div>
  </form>

  <!-- Oikeustiedot -->
  <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between">
    <h3>Tilintarkastajan oikeudet</h3>
    <mat-slide-toggle [checked]="naytaVainVoimassaolevatOikeudetSubject | async" (change)="naytaVainVoimassaolevatChange($event.checked)"> Näytä vain voimassaolevat </mat-slide-toggle>
  </div>
  @if (oikeudetObservable | async; as oikeudet) {
    <div class="oikeudet">
      @if (oikeudet?.length == 0) {
        <div>Ei oikeuksia.</div>
      }
      @if (oikeudet?.length > 0) {
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px">
          <thead>
            <tr style="background-color: #f5f5f5; border-bottom: 2px solid #ddd">
              <th style="padding: 10px; text-align: left">Asiakas</th>
              <th style="padding: 10px; text-align: left">Tilikausi</th>
              <th style="padding: 10px; text-align: left">Luotu</th>
              <th style="padding: 10px; text-align: left">Voimassaolo päättyy</th>
              <th style="padding: 10px; text-align: left">Päättymisen syy</th>
              @if (kirjanpitajaOnDevaajaObservable | async) {
                <th style="padding: 10px; text-align: left">URI</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (oikeus of oikeudet; track oikeus) {
              <tr style="border-bottom: 1px solid #eee">
                <td style="padding: 10px">{{ oikeus.asiakasNimi }}</td>
                <td style="padding: 10px">{{ oikeus.tilikausiAlkaa | lokaalipvm | async }} - {{ oikeus.tilikausiLoppuu | lokaalipvm | async }}</td>
                <td style="padding: 10px">{{ oikeus.luotu | ltimestamptime | async }}</td>
                <td style="padding: 10px">{{ oikeus.voimassaoloPaattyy | ltimestamptime | async }}</td>
                <td style="padding: 10px">{{ oikeus.paattymisenSyy || '-' }}</td>
                @if (kirjanpitajaOnDevaajaObservable | async) {
                  <td style="padding: 10px">
                    <a [href]="(oikeudetEncodedUriObservable | async) + '/' + oikeus.avain" target="_BLANK" style="font-size: 12px; color: #666">{{ oikeus.avain }}</a>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }

  <div style="padding: 20px 0px"></div>

  <!-- Kutsuminen järjestelmään -->
  <h3>Kutsu tilintarkastajaa järjestelmään</h3>
  <div>Tilintarkastajalle lähetetään sähköposti, jossa olevan linkin kautta tilintarkastaja voi pankkitunnistautua järjestelmään.</div>

  <mat-expansion-panel class="mat-elevation-z0" style="max-width: 600px; margin-top: 16px; margin-bottom: 16px; background: transparent; border: 1px solid #e0e0e0; border-radius: 4px">
    <mat-expansion-panel-header>
      <mat-panel-title>Lähetä kutsu tilintarkastajalle</mat-panel-title>
    </mat-expansion-panel-header>

    <div style="display: flex; flex-direction: column">
      <mat-form-field>
        <mat-label>Kutsusähköpostin aihe</mat-label>
        <input matInput [formField]="kutsuviestiLomake.kutsuAihe" />
      </mat-form-field>

      <mat-form-field class="no-outline no-margin">
        <textarea matInput [formField]="kutsuviestiLomake.kutsuViestiYla" cdkTextareaAutosize [cdkAutosizeMinRows]="3"></textarea>
      </mat-form-field>

      <div style="white-space: pre-wrap; font-size: 14px; color: gray; margin: 4px 0">{{ TILINTARKASTAJA_KUTSU_VIESTIN_SISALTO_TAIKALINKKI }}</div>

      <mat-form-field class="no-outline no-margin">
        <textarea matInput [formField]="kutsuviestiLomake.kutsuViestiAla" cdkTextareaAutosize [cdkAutosizeMinRows]="3"></textarea>
      </mat-form-field>
    </div>

    <div style="margin-top: 16px">
      <app-primary-button (click)="kutsuTilintarkastaja()" actionId="Lähetä kutsulinkki tilintarkastajalle" [actionContext]="[this.tilintarkastaja().avain]" [disabled]="!lomake().valid() || !kutsuviestiLomake().valid() || tilintarkastaja().tila === 'kutsuttu'" additionalClass="mat-elevation-z4" matIcon="send"> Lähetä kutsu sähköpostitse tilintarkastajalle </app-primary-button>
    </div>
  </mat-expansion-panel>

  <div style="padding: 10px 0px"></div>

  <h3>Aiemmin lähetetyt kutsut</h3>
  @if (kutsutObservable | async; as kutsut) {
    <div class="kutsut">
      @if (kutsut?.length == 0) {
        <div>Ei aiempia kutsuja.</div>
      }
      @if (kutsut?.length > 0) {
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px">
          <thead>
            <tr style="background-color: #f5f5f5; border-bottom: 2px solid #ddd">
              <th style="padding: 10px; text-align: left">Luotu</th>
              <th style="padding: 10px; text-align: left">Lähettäjä</th>
              <th style="padding: 10px; text-align: left">Vastaanottaja</th>
              <th style="padding: 10px; text-align: left">Lähetetty</th>
              <th style="padding: 10px; text-align: left">Voimassa</th>
              @if (kirjanpitajaOnDevaajaObservable | async) {
                <th style="padding: 10px; text-align: left">URI</th>
              }
              <th style="padding: 10px; text-align: center; width: 50px"></th>
            </tr>
          </thead>
          <tbody>
            @for (kutsu of kutsut; track kutsu; let i = $index) {
              <tr style="border-bottom: 1px solid #eee; cursor: pointer" (click)="toggleKutsuDetails(i)">
                <td style="padding: 10px">{{ kutsu.luotu | ltimestamptime | async }}</td>
                <td style="padding: 10px">{{ kutsu.luojaNimi }}</td>
                <td style="padding: 10px">{{ kutsu.vastaanottaja }}</td>
                <td style="padding: 10px">{{ (kutsu.lahetetty | ltimestamptime | async) || 'Ei vielä' }}</td>
                <td style="padding: 10px">{{ (kutsu.voimassaoloPaattyy | ltimestamptime | async) || '-' }}</td>
                @if (kirjanpitajaOnDevaajaObservable | async) {
                  <td style="padding: 10px">
                    <a [href]="(kutsutEncodedUriObservable | async) + '/' + kutsu.avain" target="_BLANK" (click)="$event.stopPropagation()" style="font-size: 12px; color: #666">{{ kutsu.avain }}</a>
                  </td>
                }
                <td style="padding: 10px; text-align: center">
                  <mat-icon [style.transform]="expandedKutsuIndex === i ? 'rotate(90deg)' : 'rotate(0deg)'" style="transition: transform 0.2s">chevron_right</mat-icon>
                </td>
              </tr>
              @if (expandedKutsuIndex === i) {
                <tr style="background-color: #fafafa">
                  <td [attr.colspan]="(kirjanpitajaOnDevaajaObservable | async) ? 7 : 6" style="padding: 15px">
                    <div style="max-width: 800px">
                      <div style="margin-bottom: 10px"><strong>Aihe:</strong> {{ kutsu.viestinAihe }}</div>
                      <div>
                        <strong>Viestin sisältö:</strong>
                        <div style="margin-top: 5px; padding: 10px; background-color: white; border: 1px solid #ddd; border-radius: 4px; white-space: pre-wrap; font-size: 14px" [innerHTML]="kutsu.sanitizedViestinSisalto"></div>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      }
    </div>
  }
</div>
